import React, { useState, useRef, useEffect } from 'react';
import Breadcrumb from '@/components/common/Breadcrumb';
import Card from '@/components/ui/cards/Card';
import CardBody from '@/components/ui/cards/CardBody';
import CardHeader from '@/components/ui/cards/CardHeader';
import { Input } from '@/components/ui/inputs/input';
import { updateAdminService, getByIdAdminService, getAdminDataService } from '@/services/AdminServices';
import { useForm, Controller } from 'react-hook-form';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';

const EditProfilePage = ({ pageTitle }) => {
    const { isAuthenticated, userData } = useSelector((state) => state?.Auth);
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();

    const [itemStatus, setItemStatus] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);

    useEffect(() => {
        getDataById(userData?._id);
    }, []);

    const getDataById = (editId) => {
        setIsLoading(true);
        dispatch(getByIdAdminService(editId))
            .then((res) => {
                var formData = res?.data?.data;
                for (const key in formData) {
                    if (formData.hasOwnProperty(key) && formData[key] != '') {
                        setValue(key, formData[key]);
                    } else {
                        setValue(key, '');
                    }
                }
                if (formData) {
                    setValue('status', formData.status);
                    setItemStatus(formData.status);
                }
                setValue('password', '');
                setValue('confirm_password', '');
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const onSubmit = (data) => {
        setIsFormSumbmit(true);
        dispatch(updateAdminService(userData?._id, data))
            .then((res) => {
                dispatch(getAdminDataService(userData?._id))
                    .then(() => {})
                    .catch(() => {});
                setIsFormSumbmit(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    return (
        <>
            <Breadcrumb pageTitle={pageTitle} />
            <Card>
                <CardHeader isBorder={true}>
                    <h3 className="db-card-title">{pageTitle}</h3>
                </CardHeader>
                <CardBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <Controller
                                control={control}
                                rules={{ required: true, minLength: 2, maxLength: 20 }}
                                name="name"
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        labelStyleClassName="db-field-title required"
                                        size="sm"
                                        labelText={'Name'}
                                        type="text"
                                        errorData={{ minLength: '2', maxLength: '20' }}
                                        errorType={errors?.name?.type}
                                    />
                                )}
                            />

                            <Controller
                                control={control}
                                rules={{ required: true, pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/ }}
                                name="email"
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        labelStyleClassName="db-field-title required"
                                        size="sm"
                                        labelText={'Email'}
                                        type="text"
                                        errorData={{ minLength: '6', maxLength: '20' }}
                                        errorType={errors?.email?.type}
                                    />
                                )}
                            />

                            <Controller
                                control={control}
                                rules={{ required: true, minLength: 10, maxLength: 12 }}
                                name="phone_no"
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        labelStyleClassName="db-field-title required"
                                        size="sm"
                                        labelText={'Phone'}
                                        type="text"
                                        id="phone"
                                        errorData={{ minLength: '10', maxLength: '12' }}
                                        errorType={errors?.phone_no?.type}
                                    />
                                )}
                            />
                            <div className="sm:col-span-2">
                                <button type="submit" className="db-btn text-white bg-primary" disabled={isFormSumbmit || isLoading ? true : false}>
                                    <i className="lab lab-save"></i>
                                    <span>Save</span>
                                    {isFormSumbmit ? (
                                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <></>
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                </CardBody>
            </Card>
        </>
    );
};

export default EditProfilePage;
